import {COMPANY, CLASSIFIERS, CLASSIFIER, SUB_CLASSIFIER} from "./endpoints";
import API from "../utils/apiUtils";
import { getPathParam, serialize } from "../utils/converter";

// classifier




export const getClassifiers = ({ company_id, params, signal }) =>
  API.get(
    getPathParam([COMPANY, company_id, CLASSIFIERS]) +
      (params ? serialize(params) : ""),
    { signal: signal }
  );




export const getClassifier = ({ company_id, classifier_id, signal }) =>
  API.get(getPathParam([COMPANY, company_id, CLASSIFIER, classifier_id]), {
    signal: signal,
  });



export const getSubClassifier = ({ classifier_id, params }) =>
    API.get(
        getPathParam([ CLASSIFIER, classifier_id, SUB_CLASSIFIER]) +
        (params ? serialize(params) : "")
    );


export const getCategory = ({ company_id, classifier_id, signal }) =>
  API.get(getPathParam([COMPANY, company_id, CLASSIFIER, classifier_id]), {
    signal: signal,
  });

export const postCategory = ({ company_id, data }) =>
  API.post(getPathParam([COMPANY, company_id, CLASSIFIER]), data);

export const putCategory = ({ company_id, classifier_id, data }) =>
  API.put(getPathParam([COMPANY, company_id, CLASSIFIER, classifier_id]), data);
